import "./style.css";
import { CircleMenu } from "../ui/CircleMenu";

const App = () => {
	return (
		<div className="App">
			<CircleMenu />
		</div>
	);
};

export default App;
